import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { sub } from "date-fns";
import { type FC, useEffect, useState } from "react";
import { useContractId } from "../../../context/ContractIDContext";
import { usePrimaryAPIClient } from "../../../context/PrimaryAPIClient";
import {
	fundsFilter,
	type fundsFilterType,
	fundsFormat,
	type fundsFormattedType,
	fundsSort,
	initialValues,
} from "./chartCardFunctions";
import ChartCardLayout from "./ChartCardLayout";

export const DPSChartCard: FC = () => {
	const [funds, setFunds] = useState<fundsFormattedType>([]);
	const [formValues, setFormValues] = useState<fundsFilterType>({
		dateTo: new Date(),
		dateFrom: sub(new Date(), { years: 1 }),
		funds: {},
	});
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const { contractsDpsApi } = usePrimaryAPIClient();
	const { contractId: id } = useContractId();
	const ai = useAppInsightsContext();

	useEffect(() => {
		async function loadData() {
			const rawFunds = await contractsDpsApi.getDPSFundsGet({
				contractId: id,
			});

			if (rawFunds.length === 0) {
				ai.trackEvent(
					{ name: "No DPS/PP funds data" },
					{ contractId: id, isDPS: true }
				);
			}

			const funds = fundsFormat(fundsSort(rawFunds));
			setFunds(funds);
			setFormValues(initialValues(funds));
		}

		void loadData();
	}, [ai, contractsDpsApi, id]);

	return (
		<>
			{funds.length > 0 && (
				<ChartCardLayout
					funds={funds}
					data={fundsFilter(funds, formValues)}
					isOpen={isOpen}
					setIsOpen={setIsOpen}
					setFormValues={setFormValues}
				/>
			)}
		</>
	);
}

export default DPSChartCard